/**
 * Price Timer - Handles real-time price updates based on elapsed intervals
 * 
 * This script updates prices on Shopify product and collection pages based on 
 * timer configuration in the data-timer-config element.
 */

(function() {
  // Execute when DOM is fully loaded
  document.addEventListener('DOMContentLoaded', initPriceTimer);
  
  function initPriceTimer() {
    try {
      const cfgEl = document.querySelector('[data-timer-config]');
      if (!cfgEl) return console.info('Price timer: no config found');

      const cfg = JSON.parse(cfgEl.textContent || cfgEl.innerText || '{}');
      if (!cfg.enabled) return console.info('Price timer disabled');

      const startTime = Number(cfg.startTime) || 0; // unix seconds
      const stepMajor = Number(cfg.stepMajor) || 0; // major currency units
      const isDecrease = Boolean(cfg.isDecrease);
      const checkIntervalMinutes = Number(cfg.checkIntervalMinutes) || 1;

      // Prevent clicking the add-to-cart button until initial price sync completes.
      // Use a global flag and a capturing click handler so anchors or non-button elements are also blocked.
      let addToCartBlocked = false;
      let addToCartClickBlockerAdded = false;

      function disableAddToCart() {
        try {
          addToCartBlocked = true;
          const btn = document.querySelector('#addToCartButton');
          if (btn) {
            try { btn.setAttribute('disabled', 'disabled'); } catch(e){}
            try { btn.style.pointerEvents = 'none'; } catch(e){}
            try { btn.style.cursor = 'not-allowed'; } catch(e){}
            try { btn.setAttribute('aria-disabled', 'true'); } catch(e){}
          }

          if (!addToCartClickBlockerAdded) {
            document.addEventListener('click', function(ev) {
              try {
                if (!addToCartBlocked) return;
                const clicked = ev.target && ev.target.closest && ev.target.closest('#addToCartButton');
                if (clicked) {
                  ev.preventDefault();
                  ev.stopImmediatePropagation();
                  return false;
                }
              } catch (e) { /* ignore */ }
            }, true);
            addToCartClickBlockerAdded = true;
          }
        } catch (e) { /* silent */ }
      }

      function enableAddToCart() {
        try {
          addToCartBlocked = false;
          const btn = document.querySelector('#addToCartButton');
          if (btn) {
            try { btn.removeAttribute('disabled'); } catch(e){}
            try { btn.style.pointerEvents = ''; } catch(e){}
            try { btn.style.cursor = ''; } catch(e){}
            try { btn.removeAttribute('aria-disabled'); } catch(e){}
          }
        } catch (e) { /* silent */ }
      }

      // Ensure the add-to-cart button is blocked while we perform the initial sync/update
      disableAddToCart();

      // internal state
      let lastProcessedSteps = -1;
      let nextChangeTimer = null;
  let safetyIntervalId = null;
  let timerEnded = false;

      function markTimerEnded() {
        try {
          timerEnded = true;
          // clear scheduled timeout
          if (nextChangeTimer) { clearTimeout(nextChangeTimer); nextChangeTimer = null; }
          // clear safety interval
          if (safetyIntervalId) { clearInterval(safetyIntervalId); safetyIntervalId = null; }
          // stop any further periodic checks
          // set banner state if present
          const banner = document.getElementById('collection-price-timer');
          const progress = document.getElementById('price-timer-progress');
          const countdown = document.getElementById('timer-countdown');
          if (progress) try { progress.style.width = '100%'; } catch(e){}
          if (countdown) try { countdown.textContent = '--:--:--'; } catch(e){}
          if (banner) {
            try {
              banner.style.backgroundColor = '#E11D48';
              banner.classList.add('price-timer-ended');
              banner.setAttribute('data-timer-ended', 'true');
            } catch (e) {}
          }
          if (endedMsg) try { endedMsg.style.display = 'block'; endedMsg.textContent = 'Bedre held næste gang.'; } catch(e){}
        } catch (e) { /* ignore */ }
      }

      function centsFromMajor(major) {
        return Math.round(major * 100);
      }

      // Format BSP input value from cents into bracketed major.decimal, e.g. [300.00]
      function formatBspFromCents(cents) {
        var c = typeof cents === 'string' && /^\d+$/.test(cents) ? parseInt(cents, 10) : Number(cents);
        if (isNaN(c)) return String(cents);
        var major = Math.floor(c / 100);
        var centsPart = Math.abs(c % 100);
        var centsStr = centsPart < 10 ? '0' + centsPart : String(centsPart);
        return '[' + major + '.' + centsStr + ']';
      }

      function getNowSeconds() {
        return Math.floor(Date.now() / 1000);
      }

      function getElapsedSteps() {
        const now = getNowSeconds();
        if (now <= startTime) return 0;
        const elapsedSeconds = now - startTime;
        const elapsedMinutes = Math.floor(elapsedSeconds / 60);
        if (checkIntervalMinutes <= 0) return 0;
        const steps = Math.floor(elapsedMinutes / checkIntervalMinutes);
        return steps;
      }

      function formatPriceFromCents(cents) {
        // Format like 100,00 kr
        const major = (cents / 100).toFixed(2);
        // Use comma as decimal separator for Danish formatting
        // Dynamically get currency symbol if possible, otherwise fallback to kr
        let symbol = 'kr';
        if (typeof window.Shopify !== 'undefined' && window.Shopify.currency && window.Shopify.currency.active) {
             const code = window.Shopify.currency.active;
             const map = { 'USD': '$', 'EUR': '€', 'GBP': '£', 'DKK': 'kr', 'SEK': 'kr', 'NOK': 'kr' };
             symbol = map[code] || code;
        }
        const parts = major.split('.');
        const grouped = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return grouped + ',' + parts[1] + ' ' + symbol;
      }

      // Convert milliseconds to HH:MM:SS; show placeholder when not positive
      function formatTime(ms) {
        if (ms <= 0) return '--:--:--';
        var total = Math.floor(ms / 1000);
        var hours = Math.floor(total / 3600);
        var minutes = Math.floor((total % 3600) / 60);
        var seconds = total % 60;
        return [hours, minutes, seconds].map(function(n){ return n.toString().padStart(2,'0'); }).join(':');
      }

      function parseCentsFromDisplay(display) {
        if (!display) return null;
        // display like "100,00 kr" or "1.000,00 kr" or "100.00 kr"
        let cleaned = String(display).replace('kr', '').trim();
        // remove non-numeric except comma and dot
        cleaned = cleaned.replace(/[^0-9.,]/g, '');
        // If there are both dot and comma, assume dot is thousand separator
        if (cleaned.indexOf('.') !== -1 && cleaned.indexOf(',') !== -1) {
          cleaned = cleaned.replace(/\./g, '').replace(/,/, '.');
        } else {
          // If only dot exists and more than 1 char after dot, it's decimal dot; else treat dot as thousand and remove
          if (cleaned.indexOf('.') !== -1 && cleaned.split('.').pop().length !== 2) {
            cleaned = cleaned.replace(/\./g, '');
          }
          // Convert decimal comma to dot
          cleaned = cleaned.replace(/,/, '.');
        }
        const num = parseFloat(cleaned);
        if (isNaN(num)) return null;
        return Math.round(num * 100);
      }

      function findCompareAtCents(el) {
        // try to find a nearby element with class compare_at_price and parse it
        let compareEl = el.closest('.Price') || el.closest('.pricing') || el.closest('div');
        if (compareEl) compareEl = compareEl.querySelector('.compare_at_price');
        if (compareEl) {
          const txt = compareEl.innerText || compareEl.textContent;
          return parseCentsFromDisplay(txt);
        }
        return null;
      }

      function chooseBaseline(baseOriginalAttr, parsedDisplayCents, compareCents) {
        // Prefer visible displayed price when available (avoids server-provided data-original-price causing double-add)
        if (parsedDisplayCents != null) return parsedDisplayCents;

        const candidates = [];
        if (baseOriginalAttr != null && baseOriginalAttr !== '') {
          const trimmed = String(baseOriginalAttr).trim();
          if (/^\d+$/.test(trimmed)) candidates.push(parseInt(trimmed, 10));
          else {
            const p = parseCentsFromDisplay(trimmed);
            if (p != null) candidates.push(p);
          }
        }
        if (compareCents != null) candidates.push(compareCents);

        // If no candidates, return null
        if (candidates.length === 0) return null;

        // For increases, baseline should be the smallest (current sale price). For decreases, pick the largest.
        if (!isDecrease) {
          return Math.min.apply(null, candidates);
        } else {
          return Math.max.apply(null, candidates);
        }
      }

      function updateFormBspInForm(form, newCents) {
        if (!form) return;
        form.querySelectorAll('input[name="properties[_bsp]"]').forEach(input => {
          input.value = formatBspFromCents(newCents);
        });
      }

      function updateFormBspForProduct(productId, newCents) {
        // Try to find forms/inputs related to this productId and set properties[_bsp]
        // Strategy: update inputs inside same product card or forms that have data-product-id
        const selectorInputs = 'input[name="properties[_bsp]"]';

        // 1) inputs with explicit data-product-id
        document.querySelectorAll(selectorInputs + '[data-product-id]').forEach(input => {
          if (input.getAttribute('data-product-id') === productId) input.value = formatBspFromCents(newCents);
        });

        // 2) inputs inside elements marked with data-product-id
        document.querySelectorAll('[data-product-id] ' + selectorInputs).forEach(input => {
          const owning = input.closest('[data-product-id]');
          if (owning && owning.getAttribute('data-product-id') === productId) input.value = formatBspFromCents(newCents);
        });

        // 3) inputs inside product card that contains an adjustable price with matching product-id
        document.querySelectorAll(selectorInputs).forEach(input => {
          const card = input.closest('.product_card, .product-card, .product');
          if (!card) return;
          const adj = card.querySelector('[data-timer-adjustable-price][data-product-id]');
          if (adj && adj.getAttribute('data-product-id') === productId) input.value = formatBspFromCents(newCents);
        });

        // 4) As last resort, update any input[name="properties[_bsp]"] inside forms that contain a hidden input with product id value
        document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
          const pidInput = form.querySelector('input[name="id"][value]');
          if (!pidInput) return;
          // Some themes set variant id instead of product id; we skip matching here to avoid wrong updates
        });
      }

      // Normalize BSP hidden inputs: convert values like [28000] => [280.00]
      function normalizeBspInputs() {
        document.querySelectorAll('input[name="properties[_bsp]"]').forEach(input => {
          try {
            let v = (input.value || '').trim();
            if (!v) return;
            // Expect bracketed list: [item,item]
            if (v[0] === '[' && v[v.length-1] === ']') {
              const inner = v.slice(1, -1).trim();
              if (inner === '') return;
              const parts = inner.split(',').map(p => p.trim()).filter(Boolean);
              const out = parts.map(item => {
                // If item is integer cents like 28000
                if (/^\d+$/.test(item)) {
                  const cents = parseInt(item, 10);
                  const major = Math.floor(cents / 100);
                  const centsPart = Math.abs(cents % 100);
                  const centsStr = centsPart < 10 ? '0' + centsPart : String(centsPart);
                  return major + '.' + centsStr;
                }
                // If already decimal with dot and 2 digits, keep
                if (/^\d+\.\d{2}$/.test(item)) return item;
                // If money formatted with comma like 280,00 or 1.280,00 kr
                const parsed = parseCentsFromDisplay(item);
                if (parsed != null) {
                  const major = Math.floor(parsed/100);
                  const centsPart = Math.abs(parsed % 100);
                  const centsStr = centsPart < 10 ? '0' + centsPart : String(centsPart);
                  return major + '.' + centsStr;
                }
                return item;
              });
              input.value = '[' + out.join(',') + ']';
            }
          } catch (e) {
            console.warn('normalizeBspInputs error', e);
          }
        });
      }

      /* Price Timer - updated to avoid double-applying on initial load
         - Syncs applied steps on initial run without changing DOM when server already rendered adjusted prices
         - Persists data-original-price and data-applied-steps
         - Applies updates only when steps change
      */
      function syncAppliedStepsOnInitialRun(steps) {
        const sign = isDecrease ? -1 : 1;
        const stepDelta = centsFromMajor(stepMajor) * sign;

        document.querySelectorAll('[data-timer-adjustable-price]').forEach(el => {
          try {
            // Read current displayed value
            const parsedDisplay = parseCentsFromDisplay(el.getAttribute('data-timer-adjustable-price') || el.innerText);

            // Read persisted original price
            const baseAttr = el.getAttribute('data-original-price');
            let baseCents = null;
            if (baseAttr) {
              const trimmed = String(baseAttr).trim();
              if (/^\d+$/.test(trimmed)) baseCents = parseInt(trimmed, 10);
              else baseCents = parseCentsFromDisplay(trimmed);
            }

            if (baseCents != null && parsedDisplay != null && stepDelta !== 0) {
              // Check if displayed price matches expected based on persisted data
              const expected = baseCents + (stepDelta * steps);
              if (Math.abs(expected - parsedDisplay) <= 5) {
                // If matches, just update applied steps
                el.setAttribute('data-applied-steps', String(steps));
                // Update displayed price to ensure consistency (in case of minor rounding differences)
                el.setAttribute('data-timer-adjustable-price', formatPriceFromCents(parsedDisplay));
                el.innerText = formatPriceFromCents(parsedDisplay);
                return;
              }
              // if displayed differs, compute implied and persist but do not change DOM
              const implied = Math.round((parsedDisplay - baseCents) / stepDelta);
              if (!isNaN(implied)) {
                el.setAttribute('data-applied-steps', String(implied));
                // persist base for future reference
                el.setAttribute('data-original-price', String(baseCents));
                return;
              }
            }

            // If no base known but display exists, use compare_at or leave unchanged but persist inferred values conservatively
            const compare = findCompareAtCents(el);
            if (compare != null && parsedDisplay != null && stepDelta !== 0) {
              const inferredFromCompare = Math.round((parsedDisplay - compare) / stepDelta);
              if (!isNaN(inferredFromCompare)) {
                el.setAttribute('data-applied-steps', String(inferredFromCompare));
                el.setAttribute('data-original-price', String(compare));
                return;
              }
            }

            // Conservative default: do not modify DOM on initial run when baseline can't be confidently derived
          } catch (err) {
            console.error('Price timer (sync):', err);
          }
        });
      }

      // Core: update prices by adding only new steps to the data-timer-adjustable-price, with optional cap by data-original-price
      function updatePricesForSteps(steps) {
        if (timerEnded) return;
        const sign = isDecrease ? -1 : 1;
        const stepDelta = centsFromMajor(stepMajor) * sign; // cents per step (signed)

        document.querySelectorAll('[data-timer-adjustable-price]').forEach(el => {
          try {
            const appliedStepsAttr = el.getAttribute('data-applied-steps');
            const appliedSteps = (appliedStepsAttr != null && appliedStepsAttr !== '') ? parseInt(appliedStepsAttr, 10) : null;

            // Parse current displayed adjustable price (authoritative for incremental adds)
            const displayedCents = parseCentsFromDisplay(el.getAttribute('data-timer-adjustable-price') || el.innerText);
            if (displayedCents == null) {
              console.warn('Price timer: cannot parse displayed price for', el);
              return;
            }

            // Read cap (data-original-price) if present — treat as maximum allowed price
            const capAttr = el.getAttribute('data-original-price');
            const capCents = (capAttr && String(capAttr).trim() !== '') ? (/^\d+$/.test(String(capAttr).trim()) ? parseInt(String(capAttr).trim(), 10) : parseCentsFromDisplay(capAttr)) : null;

            // If appliedSteps is not set, this is initial load: persist current steps and do not change visible price
            if (appliedSteps == null) {
              el.setAttribute('data-applied-steps', String(steps));
              // ensure displayed value is normalized
              el.setAttribute('data-timer-adjustable-price', formatPriceFromCents(displayedCents));
              return;
            }

            // Compute difference in steps to apply
            const stepDiff = steps - appliedSteps;
            if (stepDiff === 0) return;

            // Compute new displayed value by adding incremental delta to current displayed price
            let newCents = displayedCents + (stepDelta * stepDiff);

            // If cap exists and stepDelta increases price, ensure we do not exceed cap
            if (capCents != null) {
              if (!isDecrease) { // increasing timer: cap newCents to capCents
                if (newCents > capCents) newCents = capCents;
              } else { // decreasing timer: cap newCents to not go below capCents
                if (newCents < capCents) newCents = capCents;
              }
            }

            // Persist new displayed price and applied steps
            el.setAttribute('data-timer-adjustable-price', formatPriceFromCents(newCents));
            el.innerText = formatPriceFromCents(newCents);
            el.setAttribute('data-applied-steps', String(steps));

            // Update related inputs/fields
            const productId = el.getAttribute('data-product-id');
            if (productId) updateFormBspForProduct(productId, newCents);
            else {
              const form = el.closest('form'); if (form) updateFormBspInForm(form, newCents);
            }

          } catch (err) {
            console.error('Price timer: error updating element', el, err);
          }
        });

        // Additionally update BSP inputs in product cards
        document.querySelectorAll('input[name="properties[_bsp]"]').forEach(input => {
          const card = input.closest('.product_card, .product-card, .product');
          if (!card) return;
          const adj = card.querySelector('[data-timer-adjustable-price]');
          if (!adj) return;
          const adjVal = adj.getAttribute('data-timer-adjustable-price');
          if (!adjVal) return;
          const cents = parseCentsFromDisplay(adjVal) || 0;
          input.value = formatBspFromCents(cents);
        });
      }

      function scheduleNextCheck() {
        const now = getNowSeconds();
        const elapsedSeconds = now - startTime;
        const elapsedMinutes = Math.floor(elapsedSeconds / 60);
        const currentInterval = Math.floor(elapsedMinutes / checkIntervalMinutes);
        const nextChangeTimestamp = startTime + ((currentInterval + 1) * checkIntervalMinutes * 60);
        const msUntilNextChange = (nextChangeTimestamp - now) * 1000;

        if (nextChangeTimer) clearTimeout(nextChangeTimer);

        // If max intervals is reached we should not schedule further updates
        try {
          const maxNode = document.getElementById('collection-max-intervals');
          const banner = document.getElementById('collection-price-timer');
          const maxIntervals = maxNode && maxNode.dataset && maxNode.dataset.maxIntervals ? parseInt(maxNode.dataset.maxIntervals, 10) : null;
          if (!isNaN(maxIntervals) && maxIntervals >= 0 && lastProcessedSteps !== -1) {
            const stepsNow = getElapsedSteps();
            if (stepsNow >= maxIntervals) {

              markTimerEnded();
              return;
            }
          }
        } catch (e) { /* ignore */ }

        // If it's already past nextChangeTimestamp (possible clock skew), run soon
        const scheduleMs = (msUntilNextChange <= 0 || msUntilNextChange > checkIntervalMinutes * 60 * 1000 * 2) ? 500 : msUntilNextChange + 150;
        nextChangeTimer = setTimeout(() => {
          checkAndUpdate();
        }, scheduleMs);
      }

      function checkAndUpdate() {
  if (timerEnded) return;
        const steps = getElapsedSteps();
        // On first run apply updates immediately instead of only syncing
        if (lastProcessedSteps === -1) {
          updatePricesForSteps(steps);
          lastProcessedSteps = steps;
          // enable add-to-cart only after initial price update has been applied
          try { enableAddToCart(); } catch(e){}
          scheduleNextCheck();
          return;
        }

        if (steps !== lastProcessedSteps) {
          updatePricesForSteps(steps);
          lastProcessedSteps = steps;
        }
        scheduleNextCheck();
      }

      // Kick off
      try {
        normalizeBspInputs();
      } catch (e) {
        console.warn('normalizeBspInputs failed', e);
      }

      // Initial update
      checkAndUpdate();

      // Safety interval - re-check periodically in background
      safetyIntervalId = setInterval(() => {
        if (timerEnded) { if (safetyIntervalId) { clearInterval(safetyIntervalId); safetyIntervalId = null; } return; }
        try {
          const maxNode = document.getElementById('collection-max-intervals');
          const maxIntervals = maxNode && maxNode.dataset && maxNode.dataset.maxIntervals ? parseInt(maxNode.dataset.maxIntervals, 10) : null;
          if (!isNaN(maxIntervals) && maxIntervals >= 0) {
            const steps = getElapsedSteps();
            if (steps >= maxIntervals) { markTimerEnded(); return; }
          }
        } catch (e) { /* ignore */ }
        const stepsNow = getElapsedSteps();
        if (stepsNow !== lastProcessedSteps) checkAndUpdate();
      }, Math.max(30, Math.floor(checkIntervalMinutes * 60 / 3)) * 1000);

    } catch (error) {
      console.error('Error initializing price timer:', error);
    }
  }
})();